module.exports = __webpack_public_path__ + "static/assets/f1e8003f66e872246627bcc61450ab2e.svg";